export default "__VITE_ASSET__BtRN4Wzu__"